<template>
  <div>
    <TopBar pagetitle="工作机会" back-url="/users/index" />
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div v-for="item in list" :key="item.portal_jobs_id" class="jobRect pagebody">
        <div class="title pageTitle1"> {{ item.portal_jobs_title }}</div>
        <div class="topLine">
          <van-row class="pagebody2 aboutStr">
            <van-col span="2"><i class="iconfont iconcountry" /></van-col>
            <van-col span="6" class="newLine">{{ getCountryText(item.portal_jobs_country) }}</van-col>
            <van-col span="2"><i class="iconfont iconchengshi" /></van-col>
            <van-col span="6" class="newLine">{{ item.portal_jobs_region }}</van-col>
            <van-col span="2"><i class="iconfont iconjob" /></van-col>
            <van-col span="6" class="newLine">{{ item.portal_jobs_qualification }}</van-col>
            <!-- <van-col span="6" style="text-align:right">{{ formatDate(item.portal_jobs_creation_date,'yyyy-MM-dd') }}</van-col> -->
          </van-row>
        </div>
        {{ item.portal_jobs_description }}
        <div class="bottomLine pagebody1 aboutStr">
          <van-row v-if="item.portal_jobs_languages">
            <van-col span="2"><i class="iconfont iconLanguage" /></van-col>
            <van-col span="22">{{ processLanguage(item.portal_jobs_languages) }}</van-col>
          </van-row>
          <van-row v-if="item.portal_jobs_contact_www">
            <van-col span="2"><i class="iconfont iconwww" /></van-col>
            <van-col span="22" class="newLine">{{ item.portal_jobs_contact_www }}</van-col>
          </van-row>

          <van-row v-if="item.portal_jobs_contact_person">
            <van-col span="2"><i class="iconfont iconperson" /></van-col>
            <van-col span="22" class="newLine">{{ item.portal_jobs_contact_person }}</van-col>
          </van-row>
          <van-row v-if="item.portal_jobs_contact_person_phone">
            <van-col span="2"><i class="iconfont iconTel" /></van-col>
            <van-col span="22" class="newLine">{{ item.portal_jobs_contact_person_phone }}</van-col>
          </van-row>
          <van-row v-if="item.portal_jobs_contact_person_email">
            <van-col span="2"><i class="iconfont iconemail" /></van-col>
            <van-col span="17" class="newLine">{{ item.portal_jobs_contact_person_email }}</van-col>
          </van-row>

          <!-- <van-row>
            <van-col span="18"><i class="iconfont iconabout" />{{ item.portal_jobs_contact_person_email }}</van-col>
            <van-col span="6" style="text-align:right">{{ formatDate(item.portal_jobs_creation_date,'yyyy-MM-dd') }}</van-col>
          </van-row> -->
          <div class="dateTime pagebody2">
            {{ formatDate(item.portal_jobs_creation_date,'yyyy-MM-dd') }}
          </div>
        </div>

      </div>
    </van-list>
  </div>
</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { List } from 'vant'
import { initPage, formatDate, getCountryText, getLanguageText } from '@/utils/base'
export default {
  components: {
    TopBar,
    [List.name]: List
  },
  data() {
    return {
      list: [],
      page: 1,
      limit: 30,
      error: false,
      loading: false,
      finished: false
    }
  },
  created() {
    initPage()
    this.page = 1
    this.list = []
    this.onLoad()
  },
  methods: {
    formatDate,
    getCountryText,
    processLanguage(body) {
      var list = body.split(',')
      var result = []
      list.forEach(item => {
        result.push(getLanguageText(item))
      })
      return result.join(', ')
    },
    onLoad() {
      this.loading = true
      request({
        url: '/data/getJobs',
        method: 'post',
        data: {
          page: this.page,
          limit: this.limit
        }
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        console.log(response)
        this.limit = response.data.limit
        this.page = response.data.page + 1
        response.data.rows.forEach(item => {
          this.list.push(item)
        })
        if (response.data.rows.length < this.limit) {
          this.finished = true
        }
      })
    }
  }
}
</script>

<style scoped>
.jobRect{
    margin: 1em;
    padding: 0.3em 1em;
    background-color: #fff;
}
.jobRect .title{
    padding: 0.9em 0;
    width: 100%;
    border-bottom: 2px solid #d0d0d0;
}
.jobRect .dateTime{
    float:right;
    margin-top:-1em;
}
.jobRect .bottomLine i{
    margin-right: 0.5em;
    width: 100%;
}
.topLine{
margin: 0.6em 0;
}
.bottomLine{
margin: 0.6em 0;
}
</style>

